//#region src/queue.ts
var queue_default = (options = {}) => {
	const { max = 200 } = options;
	const queue = [];
	const size = () => queue.length;
	const enqueue = (item) => {
		if (size() < max) queue.push(item);
	};
	const dequeue = () => queue.shift();
	const dequeueAll = (fn) => {
		while (size() > 0) fn(dequeue());
	};
	return {
		size,
		enqueue,
		dequeueAll
	};
};

//#endregion
export { queue_default as default };
//# sourceMappingURL=queue.js.map